import React from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import Select from "react-select";
import Loader from "../../helpers/loader";
import API from "../../helpers/endpointservice";
import axios from "axios";
import $ from "jquery";
import CommonIcon from "../../helpers/icons";
import WarningComponent from "../../helpers/modal";
import Toaster from "../../helpers/toaster";
import PaginationComponent from "../../helpers/Pagination";
import { logoutFunction } from "../../custom/logoutFunction";
import swal from "sweetalert";
import moment from "moment";

const styles = {
  placeholder: (provided) => ({
    ...provided,
    whiteSpace: "noWrap",
    textOverflow: "ellipsis",
  })
}

class Category2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      sortBy: "parentCategoryName",
      category1List: [],
      currentUser: "",
      isCategory2Loader: false,
      addcategory1: false,
      height: window.innerHeight,
      isMobile: false,
      isRadioMobile: false,
      isSmallMobile: false,
      iswebMobile: false,
      category2List: undefined,
      category2ArryList: [],
      isCategory2AddHide: false,
      pageNewCount: false,
      isCategory2DeleteHide: false,
      isCategory2EditHide: false,
      currentEdit: 0,
      currentPage: 1,
      perPage: 20,
      userId: 0,
      totalCount: 0,
      pageCount: 20,
      category1Value: [],
      category1SearchInput: "",
      category2SearchInput: "",
      isSearch: false,
      addcategoryValue: {
        categoryName: "",
        isSubCategory: false,
        categoryId: 0,
        parentCategoryId: 0,
        parentCategoryName: ""
      },
      editcategoryValue: {
        categoryName: "",
        isSubCategory: false,
        categoryId: 0,
        parentCategoryId: 0,
        parentCategoryName: ""
      },
      isView: false,
      categoryNameLimitExceed: false
    };
  }
  componentDidMount() {
    let user = localStorage.getItem("UserId");
    let value = localStorage.getItem("Role").split(",")[0];
    this.state.currentUser = value;
    this.state.userId = user;
    this.setState({}, () => {
      this.GetCategory2List();
    })
    $("body").removeClass("scrollhide");
    setInterval(() => {
      this.resize();
    }, 10);
  }

  fetchPaginationList = (currentpage, perpage) => {
    this.state.currentPage = currentpage;
    this.state.perPage = perpage;
    this.setState({}, () => {
      this.GetCategory2List()
    });
  };

  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    if (window.innerWidth < 750) {
      this.state.isSmallMobile = true;
    } else {
      this.state.isSmallMobile = false;
    }
    if (window.innerWidth < 490) {
      this.state.isRadioMobile = true;
    } else {
      this.state.isRadioMobile = false;
    }
    if (window.innerWidth < 400) {
      this.state.iswebMobile = true;
    } else {
      this.state.iswebMobile = false;
    }

    this.state.height = window.innerHeight;
    this.setState({});
  };
  GetCategory2List = (page) => {
    const { currentPage, perPage } = this.state;
    let order = this.state.order === 'asc' ? true : false;
    let apiUrl = `${API.GET_CATEGORY2}?sortBy=${this.state.sortBy}&isSortAscending=${order}&category2Id=0&pageNumber=${parseInt(currentPage)}&pageSize=${parseInt(perPage)}`;
    this.setState({ isCategory2Loader: true, isCategory2Failed: false });
    axios({
      method: "POST",
      url: apiUrl,
      // data: this.state.isSearch ? {
      //   category1Name: this.state.category1SearchInput,
      //   category2Name: this.state.category2SearchInput
      // } : {}
      data: {
        category1Name: this.state.category1SearchInput,
        category2Name: this.state.category2SearchInput
      }
    }).then((res) => {
      if (res.status === 200) {
        this.state.category2List = res.data.values;
        this.state.totalCount = res.data.totalCount;
        this.state.isSearch = false;
        this.setState({}, () => {
          this.GetCategory1DropdownList()
        });

      }
    }).catch((error) => {
      logoutFunction(error?.response?.status);
      this.setState({ isCategory2Loader: false, isCategory2Failed: false });
      console.log(error);
      swal("Error!", "Something went wrong. Please try again.", "warning");
    });
  };
  GetCategory1DropdownList = () => {
    const { dispatch } = this.props;
    let apiUrl = `${API.GET_CATEGORIES}?type=category1&category1=0`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          var category1List = res?.data?.map((code) => {
            return {
              value: code.id,
              label: code.name
            };
          })
          dispatch({ type: "Category1List", data: category1List });
          this.setState({ isCategory2Loader: false, isCategory2Failed: false });

        }
      }).catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isCategory2Loader: false, isCategory2Failed: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };
  handlecategoryInputchange(e, field, type) {
    if (type === "Add") {
      if (field === "parentCategoryName") {
        if (e === null) {
          this.state.category1Value = [];
          this.setState({});
        } else {
          this.state.category1Value = e;
          this.setState({});
        }
      } else {
        if (e?.target?.value.trim().length > 250) {
          this.state.categoryNameLimitExceed = true;
        }
        else {
          this.state.addcategoryValue[field] = e.target.value;
          this.state.categoryNameLimitExceed = false;
          this.setState({});
        }
      }
    } else if (type === "Edit") {
      if (e?.target?.value.trim().length > 250) {
        this.state.categoryNameLimitExceed = true;
      }
      else {
        this.state.editcategoryValue[field] = e.target.value;
        this.setState({});
        this.state.categoryNameLimitExceed = false;
      }
    }
  }
  categoryDetails = (Id) => {
    if (Id === 0) {
      this.setState({ currentEdit: 0, categoryNameLimitExceed: false }, () => {
        let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("addCategory2Screen"));
        myOffcanvas.show();
        this.state.category2ArryList = [];
        this.setState({});
        $("body").addClass("scrollhide")
      })
    } else {
      this.setState({ currentEdit: Id, categoryNameLimitExceed: false }, () => {
        this.GetCategoryValue(false)
      })
    }

  };

  handleCheckbox = (x) => {
    const { category2ArryList } = this.state;
    if (category2ArryList?.length == 0) {
      category2ArryList.push(x);
    } else {
      if (
        category2ArryList && category2ArryList?.filter((i) => i == x)?.length == 1
      ) {
        category2ArryList?.map((i, ind) => i == x ? category2ArryList.splice(ind, 1) : "");
      } else {
        category2ArryList.push(x);
      }
    }
    this.setState({});
  };

  handleCheckboxTop = () => {
    let data = [];
    if (
      this.state.category2ArryList?.length != this.state.category2List?.length && this.state.category2ArryList?.length > 0 &&
      this.state.category2List?.length > 0
    ) {
      this.state.category2List?.map((r) => data.push(r.categoryId));
    }

    if (
      this.state.category2ArryList?.length == 0 &&
      this.state.category2List?.length > 0
    ) {
      this.state.category2List?.map((r) => data.push(r.categoryId));
    }

    if (
      this.state.category2ArryList?.length == this.state.category2List?.length &&
      this.state.category2List?.length > 0
    ) {
      data = [];
    }
    this.state.category2ArryList = data;
    this.setState({});
  };
  GetCategoryValue = (isview, id) => {
    const { currentPage, perPage } = this.state;
    var ids = this.state.category2ArryList;
    var CategoryId = ids?.toString() || id;
    this.setState({ isCategory2Loader: true, isCategory2Failed: false, categoryNameLimitExceed: false });
    let apiUrl = `${API.GET_PARDICULAR_CATEGORY}?categoryId=${CategoryId}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          const GetData = {
            categoryName: res.data.categoryName ? res.data.categoryName : "",
            isSubCategory: true,
            categoryId: res.data.categoryId ? res.data.categoryId : 0,
            parentCategoryId: res.data.parentCategoryId ? res.data.parentCategoryId : 0,
            parentCategoryName: res.data.parentCategoryName ? res.data.parentCategoryName : "",
            historyLog: res.data.historyLog
          };
          this.state.editcategoryValue = GetData;
          this.setState({});

          const newLocal = "editCategory2Screen";
          let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById(newLocal));
          myOffcanvas.show();
          $("body").addClass("scrollhide")
          this.setState({ isCategory2Loader: false, isCategory2Failed: false, isView: isview });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isCategory2Loader: false, isCategory2Failed: false, isView: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };
  AddCategory() {
    const { userId } = this.state;
    const inputs = document.querySelectorAll('.addcategory-input');
    const isValid = Array.from(inputs).every(input => input.value !== '');
    const removeBorder = Array.from(inputs).filter(input => input.value != '');
    removeBorder?.forEach(input => {
      input.style.borderColor = '';
    });
    if (this.state.category1Value?.length === 0) {
      this.state.addcategory1 = true;
    } else {
      this.state.addcategory1 = false;
    }
    this.setState({})
    if (isValid && this.state.addcategory1 === false) {
      let Categoryadd =
      {
        categoryName: this.state.addcategoryValue.categoryName,
        isSubCategory: true,
        categoryId: this.state.addcategoryValue.categoryId == undefined ? 0 : parseInt(this.state.addcategoryValue.categoryId),
        parentCategoryId: this.state.category1Value.value,
        parentCategoryName: this.state.category1Value.label
      };
      let apiurl1 = `${API.EXIST_CATEGORY}?category1Id=${this.state.category1Value.value}&categoryname=${Categoryadd.categoryName}&type=category2&id=${Categoryadd.categoryId}`;
      this.setState({ isCategory2Loader: true, isCategory2Failed: false });
      axios({
        method: "GET",
        url: apiurl1,
      }).then((res) => {
        if (res.data === false) {
          let apiUrl = `${API.POST_CATEGORY}?userId=${userId}`;
          this.setState({ isCategory2Loader: true, isCategory2Failed: false });
          axios({
            method: "POST",
            url: apiUrl,
            data: Categoryadd,
          })
            .then((res) => {
              if (res.status === 200) {
                this.ClearAddCategory2();
                this.GetCategory2List();
                toast.success("Category added successfully", {
                  position: toast.POSITION.TOP_RIGHT,
                  color: "#fff",
                });

                this.setState({
                  isCategory2Loader: false,
                  isCategory2Failed: false,
                });
              }
            })
            .catch((error) => {
              logoutFunction(error?.response?.status);
              console.log(error);
              // toast.error(
              //   "Failed to add category.",
              //   {
              //     position: toast.POSITION.TOP_RIGHT,
              //     color: "#fff",
              //   }
              // );
              swal("Error!", "Something went wrong. Please try again.", "warning");
              this.setState({ isCategory2Loader: false, isCategory2Failed: false, });
            });
        } else {
          this.setState({ isCategory2Loader: false, isCategory2Failed: false });
          toast.error(
            "This category name is already given. Please give another name.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        }
      });
    }
    else {
      const emptyInputs = Array.from(inputs).filter(input => input.value === '');
      if (emptyInputs?.length > 0) {
        emptyInputs.forEach(input => {
          input.style.borderColor = 'red';
          input.addEventListener('input', () => {
            if (input.value !== '') {
              input.style.borderColor = '';
            }
          });
        });
      }
    }

  }
  UpdateCategory = () => {
    const { editcategoryValue, userId } = this.state;
    let Categoryedit =
    {
      categoryName: editcategoryValue.categoryName,
      isSubCategory: true,
      categoryId: editcategoryValue.categoryId ? parseInt(editcategoryValue.categoryId) : 0,
      parentCategoryId: parseInt(editcategoryValue.parentCategoryId),
      parentCategoryName: editcategoryValue.parentCategoryName
    };
    const inputs = document.querySelectorAll('.editcategory-input');
    const isValid = Array.from(inputs).every(input => input.value !== '');
    const removeBorder = Array.from(inputs).filter(input => input.value != '');
    removeBorder?.forEach(input => {
      input.style.borderColor = '';
    });
    if (isValid) {

      let apiurl1 = `${API.EXIST_CATEGORY}?category1Id=${Categoryedit.parentCategoryId}&categoryname=${Categoryedit.categoryName}&type=category2&id=${Categoryedit.categoryId}`;
      this.setState({ isCategory2Loader: true, isCategory2Failed: false });
      axios({
        method: "GET",
        url: apiurl1,
      }).then((res) => {
        if (res.data === false) {
          let apiUrl = `${API.PUT_CATEGORY}?userId=${userId}`;
          this.setState({ isCategory2Loader: true, isCategory2Failed: false });
          axios({
            method: "PUT",
            url: apiUrl,
            data: Categoryedit,
          })
            .then((res) => {
              if (res.status === 200) {
                this.ClearCategory2Edit();
                this.GetCategory2List();
                toast.success("Category edited successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "colored",
                });
                this.setState({
                  isCategory2Loader: false,
                  isCategory2Failed: false,
                });
              }
            })
            .catch((error) => {
              logoutFunction(error?.response?.status);
              console.log(error);
              // toast.error(
              //   "Failed to edit category.",
              //   {
              //     position: toast.POSITION.TOP_RIGHT,
              //     color: "#fff",
              //   }
              // );
              swal("Error!", "Something went wrong. Please try again.", "warning");
              this.setState({ isCategory2Loader: false, isCategory2Failed: false });
            });
        } else {
          this.setState({ isCategory2Loader: false, isCategory2Failed: false });
          toast.error(
            "This category name is already given. Please give another category name.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        }
      })
    } else {
      const emptyInputs = Array.from(inputs).filter(input => input.value === '');
      if (emptyInputs?.length > 0) {
        emptyInputs.forEach(input => {
          input.style.borderColor = 'red';
          input.addEventListener('input', () => {
            if (input.value !== '') {
              input.style.borderColor = '';
            }
          });
        });
      }

    }
  };
  OpenRemoveCategory = () => {
    var ids = this.state.category2ArryList;
    let apiurl1 = `${API.DOCUMENT_EXIST}?type=category2`;
    this.setState({ isCategory2Loader: true, isCategory2Failed: false });
    axios({
      method: "POST",
      url: apiurl1,
      data: ids,
    })
      .then((res) => {
        if (res.data?.length === 0) {
          this.setState({ isCategory2Loader: false, isCategory2Failed: false });
          let cancelPopup = new window.bootstrap.Modal(document.getElementById("CancelCourseScreen"));
          cancelPopup.show();
          $("body").addClass("scrollhide")
        } else {
          this.setState({ isCategory2Loader: false, isCategory2Failed: false });
          toast.error(
            "Sorry you cannot delete the category when documents exist in it.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isCategory2Loader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  DeleteCategory = () => {
    const { editcategoryValue, userId, category2ArryList } = this.state;
    this.setState({ isCategory2Loader: true });
    let apiUrl = `${API.DELETE_CATEORY}?userId=${userId}`;
    axios({
      method: "DELETE",
      url: apiUrl,
      data: category2ArryList,
    })
      .then((res) => {
        if (res.status === 200) {
          this.clearDeletedArray();
          this.GetCategory2List();
          toast.success("Category removed successfully", {
            position: toast.POSITION.TOP_RIGHT,
            color: "#fff",
          });
          this.setState({ isCategory2Loader: false });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isCategory2Loader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };
  ClearAddCategory2 = () => {
    const inputs = document.querySelectorAll('.addcategory-input');
    const emptyInputs = Array.from(inputs).filter(input => input.value === '');
    if (emptyInputs?.length > 0) {
      emptyInputs.forEach(input => {
        input.style.borderColor = '';
      });
    }

    let data = {
      categoryName: "",
      isSubCategory: true,
      categoryId: 0,
      parentCategoryId: 0,
      parentCategoryName: ""
    };
    this.state.addcategoryValue = data;
    this.state.addcategory1 = false;
    this.state.category1Value = [];
    this.setState({});
    // $("#addCategory2Screen").removeClass("show");
    document.getElementById("closeButton").click();
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide")
  };

  ClearCategory2Edit = () => {
    const inputs = document.querySelectorAll('.editcategory-input');
    const emptyInputs = Array.from(inputs).filter(input => input.value === '');
    if (emptyInputs?.length > 0) {
      emptyInputs.forEach(input => {
        input.style.borderColor = '';
      });
    }
    this.state.category2ArryList = [];
    this.setState({});
    $("#editCategory2Screen").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide")
  };
  clearDeletedArray = () => {
    $("body").removeClass("scrollhide")
    $(".offcanvas-backdrop").removeClass("show");
    this.state.category2ArryList = [];
    this.setState({});
  };

  cancelDeletePopup = () => {
    $("body").removeClass("scrollhide")
    $(".offcanvas-backdrop").removeClass("show");
  }
  rendercategory1Title(state, val) {
    return state?.name?.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }

  sortTable = (name) => {
    if (this.state.category2List?.length !== 0) {
      if (this.state.sortBy === name) {
        this.state.sortBy = name;
        if (this.state.order === "asc") {
          var ordernew = "desc"
          this.state.order = ordernew;
        }
        else {
          var ordernew = "asc"
          this.state.order = ordernew;
        }
      }
      else {
        this.state.sortBy = name;
        this.state.order = 'asc'
      }
      this.state.currentPage = 1;
      this.state.pageNewCount = !this.state.pageNewCount;
      this.setState({}, () => {
        this.GetCategory2List()
      })
    }

  };

  openSearchFilterListView = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("searchCategoryScreen")
    );
    myOffcanvas.show();
    // this.state.isAdd = false;
    // this.state.isEdit = false;
    this.state.isSearch = true;
    this.state.isFieldEmpty = false;
    $("body").addClass("scrollhide");
  }

  searchCategoryList = () => {
    if (this.state.category1SearchInput?.trim() !== "" || this.state.category2SearchInput?.trim() !== "") {
      this.state.isFieldEmpty = false;
      this.state.isRequestLoader = true;
      this.setState({})
      $("#searchCategoryScreen").removeClass('show');
      $("body").removeClass("scrollhide")
      this.GetCategory2List();
    }
    else {
      this.setState({ isFieldEmpty: true })
    }
  }

  clearSearchList = () => {
    this.setState({
      category1SearchInput: "",
      category2SearchInput: "",
      isRequestLoader: true,
      isSearch: false
    }, () => this.GetCategory2List())
    $("#searchCategoryScreen").removeClass('show');
    $("body").removeClass("scrollhide")
  }


  render() {
    const { isCategory2Loader, pageCount, pageNewCount, isMobile, isRadioMobile, isSmallMobile, category2ArryList, category2List, addcategoryValue, currentPage, isCategory2EditHide, isCategory2AddHide, isCategory2DeleteHide, perPage, sortBy, order, editcategoryValue, } = this.state;
    let { menuToggle, category1List } = this.props
    return (
      <>
        <Toaster />
        {$("#addCategory2Screen").hasClass("show") || $("#searchCategoryScreen").hasClass("show") || $("#editCategory2Screen").hasClass("show") ? <div className='viewbar-overlay'></div> : <></>}
        <div className={`${isMobile ? "main-body-mobile" : menuToggle ? "menu-main-body" : "main-body"} `}>
          <Loader isLoader={isCategory2Loader} />
          <div className="head-fixed-company">
            {isMobile == true ? (
              <div className="mobile-head border-bottom w-100">
                <div className="col-12 mobile-title">Category 2</div>
              </div>) : (
              <div className="title">
                <CommonIcon fileName="courseCategoryMaxIcon" />{" "}<span className="pl-10 head-span">Category 2</span>
              </div>
            )}
            <div className={`${isMobile ? "" : "pl-10"} border-bottom`}>
              <div className={`col-12 d-flex justify-content-start  ${isMobile ? "pr-0 pl-17" : "p-1 pl-10"}`}>
                <button className={`displaybutton ${isRadioMobile ? "pr-5" : ""} ${isSmallMobile ? "pl-5" : ""}`} onClick={() => this.categoryDetails(0)}>
                  <CommonIcon fileName="addIcon" /> <span className={`subhead-span p-2`}>Add</span>
                </button>
                {category2ArryList?.length === 1 &&
                  <button className={`displaybutton ${isRadioMobile ? "pr-5" : ""}  ${isSmallMobile ? "pl-5" : ""}`} onClick={() => this.categoryDetails(1)}>
                    <CommonIcon fileName="EditIcon" /><span className={`subhead-span p-2`}>Edit</span>
                  </button>}
                {category2ArryList?.length !== 0 &&
                  <button className={`displaybutton ${isRadioMobile ? "pr-5" : ""}  ${isSmallMobile ? "pl-5" : ""}`} onClick={() => this.OpenRemoveCategory()}>
                    <CommonIcon fileName="RemoveIcon" /><span className={`subhead-span p-2`}>Remove</span>
                  </button>}
                <div
                  className={`position-absolute  end-0 ${isMobile ? "" : menuToggle ? "ml-role-updated" : "ml-role"
                    }`}
                >
                  <button
                    className="displaybutton"
                    onClick={this.openSearchFilterListView}
                  >
                    <span>
                      <CommonIcon fileName="filterIcon" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className={`${isMobile ? "vendor-mobile-table1" : "vendor-table1"} table-responsive w-100`}>
            <div className={`table-fixed-header ${(isMobile ? "table-scroll-xy-mobile top-150px" : menuToggle ? "table-scroll-xy-menutoggle top-upcoming-training" : "table-scroll-xy top-upcoming-training")} table-list-view-bottom`} >
              <table className={`table  fileListTable2 table-borderless table-hover ${isMobile ? "" : ""} table-responsive`} >
                <thead>
                  <tr>
                    <td>
                      <input type="checkbox" name="request" checked={category2ArryList?.length !== 0 ? (category2ArryList?.length === 1 ? false : category2ArryList?.length === category2List.length ? true : false) : false} onClick={() => this.handleCheckboxTop()} />
                    </td>
                    <td className="cursor-pointer" onClick={() => this.sortTable("parentCategoryName")}>
                      <span className="pl-20">Category 1</span>{sortBy === "parentCategoryName" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />} </td>
                    <td className="cursor-pointer" onClick={() => this.sortTable("categoryName")}>
                      <span className="vendor-span">Category 2</span>{sortBy === "categoryName" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />} </td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {category2List?.length !== 0 ?
                    category2List?.map((item, index) => (
                      <tr key={index} className={`${category2ArryList?.filter((r) => r == item.categoryId)?.length > 0 ? "background-color-table" : ""}`}>
                        <td>
                          <input type="checkbox" name="request" className="checkboxes t-input" checked={category2ArryList?.filter((r) => r == item.categoryId)?.length > 0 ? true : false} onClick={() => this.handleCheckbox(item.categoryId)} />
                        </td>
                        <td className="width-50 pl-20"><span className=" cursor-pointer  link " title={item.parentCategoryName}>{item.parentCategoryName}{" "}</span></td>
                        <td className="width-50"><span className="tablefilename cursor-pointer font-wei-600" onClick={() => this.GetCategoryValue(true, item.categoryId)} title={item.categoryName}>{item.categoryName}{" "}</span></td>
                        <td></td>
                      </tr>
                    )) :
                    <tr><td colSpan={4} className="table-nodata">{category2List && "No record found"}</td></tr>}
                </tbody>
              </table>
            </div>
          </div>

          {/* Add offcanvas */}
          <div className="offcanvas offcanvas-end offcanvasStyle" tabIndex={-1} data-bs-scroll="false" data-bs-backdrop="false" id="addCategory2Screen" aria-labelledby="offcanvasScrollingLabel">
            <div className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}>
              <h6 id="offcanvasRightLabel" className="modal-title fw-600">Add category</h6>
              <button className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : ""}`} onClick={() => this.ClearAddCategory2()} >
                <CommonIcon fileName="CrossIcon" />
              </button>{" "}
              <button
                className="display-none"
                id="closeButton"
                data-bs-dismiss="offcanvas"
              >
              </button>
            </div>
            <div className="offcanvas-body px-4 pt-0">
              <div className="row">
                <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}>
                  <label className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-2"}`}>
                    <CommonIcon fileName="courseCategoryIcon" />{" "}
                    <span className="pl-10 properties-search-span">Category 1</span> <span className="MuiFormHelperText-contained">*</span>
                  </label>
                  <div className={this.state.addcategory1 && "border-red"}>
                    <Select
                      className="text-12-normal-select equipments addcategory-input"
                      classNamePrefix="assigngroups"
                      value={this.state.category1Value}
                      options={category1List}
                      placeholder="Please select an option"
                      styles={styles}
                      menuPosition="fixed"
                      menuPlacement="auto"
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => this.handlecategoryInputchange(e, "parentCategoryName", "Add")}
                    />
                  </div>
                </div>
                <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}>
                  <div className="form-group">
                    <label className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                      <CommonIcon fileName="courseCategoryIcon" />{" "}
                      <span className="pl-10 properties-search-span">Category 2</span> <span className="MuiFormHelperText-contained">*</span>
                    </label>
                    <input onChange={(e) =>
                      this.handlecategoryInputchange(e, "categoryName", "Add")}
                      className={`form-control border-radius addcategory-input mt-2 category2-input ${this.state.categoryNameLimitExceed === true ? "Error-border" : ""}`}
                      value={this.state.addcategoryValue.categoryName} />
                  </div>
                  {this.state.categoryNameLimitExceed ? <span className="spanErrMsg">Value must be less than 250 characters</span> : <></>}
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
                <button className={`btn btn-light input-group f-size-13 d-flex offcavasclose  ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"} p-2`} onClick={() => this.AddCategory()}>
                  <CommonIcon fileName="ButtonSubmitIcon" /><span className="model-label pl-10">Submit</span>
                </button>
              </div>
            </div>
          </div>

          {/* Edit offcanvas */}
          <div className={`offcanvas offcanvas-end offcanvasStyle ${this.state.isView ? "audit-offcanvas" : ''}`} tabIndex={-1} data-bs-scroll="false" data-bs-backdrop="false" id="editCategory2Screen" aria-labelledby="offcanvasScrollingLabel">
            <div className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}>
              <h6 id="offcanvasRightLabel" className="modal-title fw-600">{this.state.isView ? "Category" : "Edit category"}</h6>
              <button className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : ""}`} onClick={() => this.ClearCategory2Edit()}>
                <CommonIcon fileName="CrossIcon" />
              </button>
            </div>
            <div className="offcanvas-body px-4 pt-0">
              {
                this.state.isView && <button className={`displaybutton ${isRadioMobile ? "pr-5" : ""}  ${isSmallMobile ? "pl-5" : "pl-0"}`} onClick={() => this.GetCategoryValue(false, editcategoryValue.categoryId)}>
                  <CommonIcon fileName="EditIcon" /><span className={`subhead-span p-2`}>Edit</span>
                </button>
              }
              <div className="row">
                <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}>
                  <div className="form-group">
                    <label
                      className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                      <CommonIcon fileName="courseCategoryIcon" />{" "}<span className="pl-10 properties-search-span">Category 1</span> <span className="MuiFormHelperText-contained">*</span>
                    </label>
                    <input
                      className='form-control border-radius shiptype-select mt-2 jobNameSize'
                      value={this.state.editcategoryValue.parentCategoryName}
                      disabled={true} />
                  </div>
                </div>
                <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}>
                  <div className="form-group">
                    <label
                      className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                      <CommonIcon fileName="courseCategoryIcon" /><span className="pl-10 properties-search-span">Category 2</span> <span className="MuiFormHelperText-contained">*</span>
                    </label>
                    <input onChange={(e) =>
                      this.handlecategoryInputchange(e, "categoryName", "Edit")}
                      disabled={this.state.isView}
                      className={`form-control border-radius editcategory-input mt-2 jobNameSize  ${this.state.categoryNameLimitExceed === true ? "Error-border" : ""}`}
                      value={this.state.editcategoryValue.categoryName} />
                  </div>
                  {this.state.categoryNameLimitExceed ? <span className="spanErrMsg">Value must be less than 250 characters</span> : <></>}
                </div>
              </div>
              {
                !this.state.isView && <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
                  <button className={`btn btn-light input-group f-size-13 d-flex offcavasclose  ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"} p-2`} onClick={() => this.UpdateCategory()}>
                    <CommonIcon fileName="ButtonSubmitIcon" /><span className="model-label pl-10">Update</span>
                  </button>
                </div>
              }
              {
                (this.state.isView || !this.state.isView) && editcategoryValue?.historyLog?.length > 0 && <div>
                  <div className="pt-3">
                    <h6 className="modal-title">Audit log</h6>
                  </div>
                  <div className="audit-table-wrapper audit-scroll-css">
                    <table className="px-3 audit-table w-100">
                      <thead>
                        <tr className="border-bottom">
                          <th className="p-rem">
                            Action
                          </th>
                          <th className="p-rem">
                            Action By
                          </th>
                          <th className="p-rem wid-45">
                            Description
                          </th>
                          <th className="p-rem">
                            Date
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          editcategoryValue?.historyLog.map(x => (
                            <tr className="border-bottom">
                              <td className="p-rem">{x.action ? x.action : "-"}</td>
                              <td className="p-rem">{x.actionBy ? x.actionBy : "-"}</td>
                              <td className="p-rem">
                                {x.description ? x.description : "-"}
                              </td>
                              <td className="p-rem">
                                {x.createdTime ? moment.utc(x.createdTime).local().format("DD-MMM-YYYY, hh:mm A") : "-"}
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              }
            </div>
          </div>
        </div >



        {/* Category List View Search */}
        <div className="offcanvas offcanvas-end offcanvasStyle" tabIndex={-1} data-bs-scroll="false" data-bs-backdrop="false" id="searchCategoryScreen" aria-labelledby="offcanvasScrollingLabel">
          <div className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}>
            <h6 id="offcanvasRightLabel" className="modal-title fw-600">Search</h6>
            <button className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : ""}`} data-bs-dismiss="offcanvas" onClick={() => { this.setState({ isSearch: false }) }}>
              <CommonIcon fileName="CrossIcon" />
            </button>
          </div>
          <div className="offcanvas-body px-4 pt-0">
            <div className="row">
              <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}>
                <div className="form-group">
                  <label className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                    <CommonIcon fileName="courseCategoryIcon" />
                    <span className="pl-10 properties-search-span">Category 1</span>
                  </label>
                  <input className={` form-control border-radius mt-2 font-size-12`}
                    onChange={(e) => {
                      this.setState({ category1SearchInput: e.target.value })
                    }}
                    // style={{ borderColor: this.state.isFieldEmpty ? "#d12232" : "" }}
                    value={this.state.category1SearchInput} />
                  {/* {this.state.isFieldEmpty ? (
                      <span className="send-rework-label">This field is required</span>
                    ) : (<></>)} */}
                </div>
              </div>
              <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2`}>
                <div className="form-group">
                  <label className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                    <CommonIcon fileName="courseCategoryIcon" />
                    <span className="pl-10 properties-search-span">Category 2</span>
                  </label>
                  <input className={` form-control border-radius mt-2 font-size-12`}
                    onChange={(e) => {
                      this.setState({ category2SearchInput: e.target.value })
                    }}
                    // style={{ borderColor: this.state.isFieldEmpty ? "#d12232" : "" }}
                    value={this.state.category2SearchInput} />
                  {/* {this.state.isFieldEmpty ? (
                      <span className="send-rework-label">This field is required</span>
                    ) : (<></>)} */}
                </div>

              </div>
            </div>
            {this.state.isFieldEmpty ? (
              <span className="send-rework-label">Atleast one field is mandatory</span>
            ) : (<></>)}
            <div className="d-flex col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
              <button className="btn rejectbutton" onClick={() => this.clearSearchList()} >
                <CommonIcon className="button-img" fileName="ButtonRejectApprovalIcon" />
                <span className="px-1">Clear</span> </button>
              <button
                className={`btn approvebutton d-flex gap-1 mx-2`}
                onClick={() => { this.searchCategoryList() }}>
                <span><CommonIcon fileName="searchableIcon" /></span>
                <span className="model-label pl-vendor3 pl-2">Search</span>
              </button>
            </div>
          </div>
        </div>

        {/* Modal - Warning */}
        <WarningComponent message={this.state.category2ArryList?.length > 1 ? "Are you sure you want to remove these categories ?" : "Are you sure you want to remove this category ?"} isMobile={this.state.isMobile} onYesClick={() => this.DeleteCategory()} />

        {/* Pagination */}
        {category2List?.length !== 0 ?
          <PaginationComponent fetchPagination={this.fetchPaginationList} pageCount={this.state.totalCount} reset={pageNewCount} /> : null}

      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    category1List: state.commonReducer.Category1List,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Category2)
);
